module.exports = __webpack_public_path__ + "img/2017_dvo.ed859f0a.jpg";